import { useCallback } from 'react';
import { isNonProd } from '~/constants/environment';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useDealershipId } from '~/context/dealership/StaticContext';

export default function usePushToAdobe() {
  const dealershipId = useDealershipId();
  const trackEvent = useTrackEvent();

  return useCallback(
    (payload: Record<string, any>) => {
      window.adobeDataLayer?.push(payload);

      trackEvent('Adobe', { dealershipId, payload });

      if (isNonProd) {
        console.debug('Push to adobe', payload);
      }
    },
    [dealershipId, trackEvent]
  );
}
